










































import Vue from "vue";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

import UserFormEditPassword from "../components/UserFormEditPassword.vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import { UserCreateForm } from "../forms/UserCreateForm";
import { Role } from "../../role/models/Role";
export default Vue.extend({
  mixins: [permission, dialog],
  components: {
    UserFormEditPassword
  },
  validations: {
    userCreateForm: {
      email: { required, email },
      passwordForm: {
        password: {
          required,
          minLength: minLength(6)
        },
        confirmPassword: {
          sameAsPassword: sameAs("password")
        }
      },
      role: {
        required
      }
    }
  },
  data() {
    const roles: Role[] = [];
    const userCreateForm: UserCreateForm = {
      email: "",
      passwordForm: {
        password: "",
        confirmPassword: ""
      }
    };
    return { userCreateForm, roles };
  },
  computed: {
    emailError() {
      return (this as any).$v.userCreateForm.email.$error
        ? "Email is required or invalid."
        : "";
    },
    roleError() {
      return (this as any).$v.userCreateForm.role.$error
        ? "Role is required or invalid."
        : "";
    },
    hasUserViewPermission() {
      return (this as any).hasPermission(PermissionName.USER_VIEW);
    }
  },
  async created() {
    await Promise.all([this.getRoles()]);
  },
  methods: {
    async getRoles() {
      try {
        const { data } = await (this as any).$dep.roleUseCase.getRoles({
          perPage: 9999
        });
        this.roles = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToUserViewPage() {
      this.$router.push({ name: "UserViewPage" });
    },
    async createUser() {
      try {
        await (this as any).$dep.userUseCase.createUser(this.userCreateForm);
        if (await (this as any).alertSuccess("Success", "เพิ่ม User สำเร็จ")) {
          this.goToUserViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง User ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to add user",
        "คุณต้องการเพิ่ม User หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createUser();
      }
    },
    clear() {
      this.$v.$reset();
      this.userCreateForm = {
        email: "",
        passwordForm: {
          password: "",
          confirmPassword: ""
        }
      };
    }
  }
});
